import React from 'react';
import Catch from './Catch';
import styled from 'styled-components';
import { Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const MyErrorBoundary = Catch((props, error) => {
  if (error) {
    return (
      <Container>
        <Title variant="h6">
          <Icon size="large" /> An error has occured
        </Title>
        <Text variant="body1">
          An unexpected error has occurred. Please, try reloading this page and
          clean your browser cache to continue. If the problem persist, please
          contact us at{' '}
          <Strong variant="body1" href="mailto: support@trueimpact.com">
            support@trueimpact.com
          </Strong>
          .
        </Text>
        <ErrorContainer elevation={3}>Details: {error.message}</ErrorContainer>
        <Link variant="body1" onClick={() => window.location.reload()}>
          Refresh Now
        </Link>
      </Container>
    );
  } else {
    return <React.Fragment>{props.children}</React.Fragment>;
  }
});

const Title = styled(Typography)`
  color: #0091ae;
`;

const Strong = styled.a`
  color: #0091ae;
`;

const Text = styled(Typography)`
  margin-top: 20px !important;
`;

const Link = styled(Typography)`
  color: #0091ae;
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
`;

const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
`;

const Icon = styled(ErrorOutlineIcon)`
  font-size: 1.6em !important;
  transform: translateY(8px);
`;

const ErrorContainer = styled.div`
  width: 100%;
  color: #ff4242;
  height: auto;
  padding: 20px;
  background-color: #f3f3f3;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export default MyErrorBoundary;
